<template>
  <transition
    name="transition-height"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'CTransitionHeight',

  emits: ['after-enter'],

  methods: {
    enter (element) {
      element.style.height = 'auto'
      const height = element.offsetHeight
      element.style.height = '0'
      // eslint-disable-next-line no-unused-expressions
      element.offsetHeight // Force reflow
      element.style.height = height + 'px'
    },
    afterEnter (element) {
      element.style.height = 'auto'
      this.$emit('after-enter')
    },
    beforeLeave (element) {
      element.style.height = element.offsetHeight + 'px'
      // eslint-disable-next-line no-unused-expressions
      element.offsetHeight // Force reflow
      element.style.height = '0'
    }
  }
}
</script>

<style lang="scss">
.transition-height-enter-active,
.transition-height-leave-active {
  @media (prefers-reduced-motion: no-preference) {
    overflow: hidden;
    transition: height 0.3s;
  }
}
</style>
